<template>
  <div :class="wrapperClasses">
    <div class="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center w-100 mb-2">

      <!-- Signature -->
      <div class="signature-container me-lg-4 me-0 mb-2 mb-lg-0" v-if="currentDigitalSignature">
        <div class="d-flex flex-column align-items-center">
          <img
              :src="currentDigitalSignature"
              class="mb-2 signature-img"
              alt="Digital Signature"/>
          <small class="text-muted fst-italic signature-label">
            — Digitale Signatur —
          </small>
        </div>
      </div>

      <!-- Buttons -->
      <div class="action-buttons d-flex align-items-center justify-content-end">
        <button
            v-if="canSeeMeetingHistory(currentUserRole) && updatedByAdmin"
            @click.prevent="$emit('open-history')"
            class="btn btn-outline-primary btn-icon me-2">
          <i class="os-icon os-icon-rotate-ccw"></i>
        </button>

        <button
            v-if="isDigitalSignature && firstInterviewId"
            class="btn btn-primary shadow-sm px-4 text-nowrap"
            @click.prevent="$emit('open-signature')">
          <i class="os-icon os-icon-edit-3 me-1"></i>
          Digitale Unterschrift
        </button>
      </div>
    </div>

    <!-- Warning -->
    <div
        v-if="isDigitalSignature && missingDigitalSignatureForFirstInterview"
        class="mt-1 animate__animated animate__fadeIn text-end">
      <span class="text-danger small fw-bold">
        <i class="os-icon os-icon-alert-circle me-1"></i>
        {{ $t('general.missing_digital_signature') }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed , defineProps} from 'vue'

const props = defineProps({
  operationType: String,
  currentUserRole: String,
  firstInterviewId: [String, Number, Boolean],
  currentDigitalSignature: String,
  isDigitalSignature: Boolean,
  missingDigitalSignatureForFirstInterview: Boolean,
  updatedByAdmin: Boolean,
  canSeeMeetingHistory: {
    type: Function,
    default: () => false
  },
  fallbackColClass: {
    type: String,
    default: 'col-lg-8'
  }
})

const wrapperClasses = computed(() => ({
  'col-lg-6':
      props.operationType === 'compass' &&
      (props.currentUserRole === 'ROLE_ADMIN' ||
          props.currentUserRole === 'ROLE_ACCOUNTANT') &&
      props.firstInterviewId,

  [props.fallbackColClass]:
      !(
          props.operationType === 'compass' &&
          (props.currentUserRole === 'ROLE_ADMIN' ||
              props.currentUserRole === 'ROLE_ACCOUNTANT') &&
          props.firstInterviewId
      ),

  'col-md-12': true,
  'col-sm-12': true,
  'd-flex': true,
  'flex-column': true,
  'align-items-end': true,
  'mt-3': true,
  'mt-md-0': true
}))
</script>

<style scoped>
.signature-img {
  width: 250px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1));
}

.signature-label {
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}
</style>